<template>
  <el-card shadow="hover">
    <div style="padding: 10px 20px">
      <el-form
        ref="formBatchImport"
        :size="$xUISize"
        :model="batchImportModel"
        :rules="batchImportRules"
        label-width="auto"
        label-position="top"
        @submit.native.prevent
      >
        <el-form-item>
          <upload-file
            :btnLabel="batchImportSubmit ? '正在导入中，请勿关闭界面' : '上传Excel文件'"
            :fileSize="10240"
            :loading="batchImportSubmit"
            :fileTplUrl="'/static/file_tpl/goods_sku_batch_update_price.xls'"
            @handleUploadFile="batchImportSubmitClick"
          >
          </upload-file>
          <div v-if="batchImportResponse" style="line-height: 22px; margin-top: 20px">
            <div>
              <span> 提交结果 </span>
            </div>
            <div>
              <span
                style="color: #409eff; margin-right: 5px"
                v-if="batchImportResponse.successCount > 0"
              >
                成功数：{{ batchImportResponse.successCount || "0" }}
              </span>
            </div>
            <div>
              <span
                style="color: #f56c6c; margin-right: 5px"
                v-if="batchImportResponse.failureCount > 0"
              >
                失败数：{{ batchImportResponse.failureCount || "0" }}
              </span>
              <span
                style="color: #919191; margin-right: 5px"
                v-if="batchImportResponse.ignoreCount > 0"
              >
                忽略数：{{ batchImportResponse.ignoreCount || "0" }}
              </span>
            </div>
            <div>
              <span style="font-size: 12px; color: #919191">
                (共{{ batchImportResponse.totalCount || "0" }}条数据)
              </span>
            </div>
            <div
              v-if="batchImportResponse.errors && batchImportResponse.errors.length > 0"
            >
              <el-table :data="batchImportResponse.errors">
                <el-table-column type="expand">
                  <template slot-scope="props">
                    {{ props.row.errorMsg }}
                  </template>
                </el-table-column>
                <el-table-column label="失败原因" prop="message" min-width="180">
                </el-table-column>
                <el-table-column prop="errorCount" label="失败次数" width="180">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div style="line-height: 22px; margin-bottom: 20px">
            <div>
              <span style="font-weight: 500"> 批量修改操作须知 </span>
            </div>
            <div>
              <span> 1，建议在导入前备份重要数据，以防万一 </span>
            </div>
            <div>
              <span> 2，仔细检查数据的准确性和完整性，避免错误数据的导入 </span>
            </div>
            <div>
              <span>
                3，导入/更新处理时间较长，请耐心等待，请勿中途关闭或退出当前界面
              </span>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import uploadFile from "../../../../components/uploadFile.vue";

export default {
  components: {
    uploadFile,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    batchImportSubmitClick(fileData) {
      this.batchImportResponse = null;
      this.$refs.formBatchImport.validate((valid, data) => {
        if (valid) {
          if (this.batchImportSubmit) {
            return;
          }
          this.batchImportSubmit = true;
          this.requestApi(
            "biz.goods.sku.info.batchUpdatePrice",
            {
              excelBase64: fileData.data,
            },
            {
              timeout: 1000 * 60 * 60 * 24,
              showError: true,
            }
          )
            .then((resp) => {
              this.success("提交成功");
              this.batchImportResponse = resp.data;
            })
            .finally(() => {
              this.batchImportSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
  },
  data() {
    return {
      batchImportModel: {
        excelBase64: "",
      },
      batchImportSubmit: false,
      batchImportResponse: null,
      batchImportRules: {},
    };
  },
};
</script>
